<template>
    <div>
        <div class="col-lg-12" v-if="isLoadingBlade">
            <div class="d-flex justify-content-center">
                <img :src="loadingBladeUrl" />
            </div>
        </div>

        <div v-if="! isLoadingBlade">
            <div class="row">
                <div class="col-lg-2">
                    <base-input alternative="">
                        <select
                            class="form-control form-control-alternative"
                            v-model="pagination.perPage"
                            @change="getPageItems()"
                        >
                            <option
                                v-for="number in entries"
                                :key="number"
                                :value="number"
                            >
                                {{ number + ' - Entries'}}
                            </option>
                        </select>
                    </base-input>
                </div>
                <div class="col-lg-8"></div>
                <div class="col-lg-2">
                    <select
                        class="form-control form-control-alternative"
                        v-model="page"
                        @change="getPageItems()"
                    >
                        <option
                            v-for="number in pageNumbers"
                            :key="number"
                            :value="number"
                        >
                            {{ 'Page ' + number }}
                        </option>
                    </select>
                </div>
            </div>
        </div>

        <!-- import records details template here -->
        <ApplicantsData
            :records="records"
            :checked="checked"
            :pagination="pagination"
            :privileges="privileges"
            :batch="batch"
            :paginate="paginate"
            :hasPagination="hasPagination"
            :loadAplications="loadAplications"
            v-if="! isLoadingBlade"
        />

        <div class="col-sm-12 text-center" v-if="records && records.length == 0">
            <base-alert :type="errorType" v-if='showErrorStatus'>
                <span class="alert-inner--icon"><i class="ni ni-like-2"></i></span>
                <span class="alert-inner--text">
                    {{errorMsg}}
                </span>
            </base-alert>
        </div>
    </div>
</template>
<script>
  import { mapGetters, mapActions } from 'vuex';
  import ApplicantsData from './ApplicantsData';

  export default {
    name: 'NotSeatedApplicants',
    props: ['batch', 'changeTitle', 'privileges', 'loadTitle', 'type', 'checked'],
    components: {
      ApplicantsData
    },
    data() {
      return {
        records: [],
        paginatedItems: [],
        pagination: {
            total: null,
            prev_page_url: null,
            next_page_url: null,
            current_page: null,
            last_page: null,
            number: 1,
            from: 0,
            to: null,
            perPage: this.$store.state.url.perPage // get per page count
        },
        showErrorStatus: false,
        errorType: null,
        errorMsg: null,
        isLoadingBlade: false,
        searchKey: '',
        page: 1
      }
    },
    computed: {
        ...mapGetters(['loadingBladeUrl']),
        hasPagination() {
          return this.pagination.next_page_url || this.pagination.prev_page_url;
        },
        pageNumbers() {
            let start = 1;
            let end = this.pagination.last_page;
            let pages = [];
            for (let i = start; i <= end; i++ ) {
                pages.push(i);
            }
            return pages;
        },
        entries() {
            return [ 20, 50, 100];
        }
    },
    methods: {
        ...mapActions(['getAssessmentApplications', 'getPaginatedExactApplications']),
        loadAplications() {
            this.isLoadingBlade = true;
            this.showErrorStatus = false;
            let data = {
                assessment_batch_id: this.batch.id,
                seat_status: this.type,
                limit : this.pagination.perPage
            }
            this.getAssessmentApplications(data).then((res) => {// get records
                this.setPages(res);
            }).
            catch(() => {
                this.showErrorStatus = true;
                this.isLoadingBlade = false;
                this.errorMsg = "Server Failure!, Kindly reload the page...";
                this.errorType = 'danger';
            });
        },
        setPages(res) {// set paginated function
            this.records = [];
            this.paginatedItems = res.data;
            this.records = this.paginatedItems;
            this.pagination.from = res.from;
            this.pagination.to = res.to;
            this.pagination.total = res.total;
            this.pagination.current_page = res.current_page;
            this.pagination.last_page = res.last_page;
            this.pagination.prev_page_url = res.prev_page_url;
            this.pagination.next_page_url = res.next_page_url;
            this.isLoadingBlade = false;
            let title = this.batch ? '<em class="text-danger">' + this.batch.title : '';
            title += this.batch ? ' - ' + this.batch.description : '';
            title += this.batch ? ' (' + this.batch.year + ')</em>' : '';
            title += ' Assessment Exam Seat Status';
            this.changeTitle(title, true)
            this.emptyRecordsMsg();//show empty msg
        },
        emptyRecordsMsg() {
            return this.records && this.records.length == 0 ? this.showEmptyMsg() : false;
        },
        showEmptyMsg() {// show empty msg
            this.showErrorStatus = true;
            this.errorType = 'warning';
            this.errorMsg = 'No Applicants Yet!!!';
        },
        getPageItems() {
            let url = this.pagination.next_page_url ?
                        this.pagination.next_page_url : this.pagination.prev_page_url;
            if(url) {
                let exploded = url.split('&');
                let newUrl = exploded[0]+'&'+exploded[1]+'&limit='+this.pagination.perPage+'&page='+this.page;

                this.isLoadingBlade = true
                this.getPaginatedExactApplications(newUrl).then((res) => {// get records
                    this.pagination.number = res.current_page;
                    this.setPages(res);
                }).
                catch(() => {
                    this.records = [];
                    this.showErrorStatus = true;
                    this.isLoadingBlade = false;
                    this.errorMsg = "Server Failure!, Kindly reload the page...";
                    this.errorType = 'danger';
                });
            }
        },
        paginate() {// paginate function
            this.showErrorStatus = false;
            let url = (this.pagination.number > this.pagination.current_page) ?
                this.pagination.next_page_url : this.pagination.prev_page_url;
            if(url) {// make api call
                this.isLoadingBlade = true
                this.getPaginatedExactApplications(url).then((res) => {// get records
                    this.pagination.number = res.current_page;
                    this.setPages(res);
                }).
                catch(() => {
                    this.records = [];
                    this.showErrorStatus = true;
                    this.isLoadingBlade = false;
                    this.errorMsg = "Server Failure!, Kindly reload the page...";
                    this.errorType = 'danger';
                });
            } else {
                this.records = this.paginatedItems;
            }
        },
    },
    mounted() {
      this.loadAplications();// load title
    }
  };
</script>
<style></style>
